// extracted by mini-css-extract-plugin
module.exports = {"GoLight":"GoLight_GoLight__r9pEa"};